import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { EdSdfFacility, EdSmartDistributionApi } from '../tokens/ed-smart-distribution.token';

/**
 * REST implementation of the E-D Smart-Distribution API (EM-822).
 *
 *   GET /services/embedded/api/v1/ed/smart-distribution/facilities
 *
 * The calling E-D is resolved server-side from the JWT (Rule 22 — no id in the URL). REST-only
 * (Rules 07/10). Bound to ED_SMART_DISTRIBUTION in mock-data.providers.ts.
 */
@Injectable({ providedIn: 'root' })
export class EdSmartDistributionRestService implements EdSmartDistributionApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/ed/smart-distribution`;

  listFacilities(): Observable<EdSdfFacility[]> {
    return this.http.get<EdSdfFacility[]>(`${this.base}/facilities`);
  }
}
